var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBasicProducer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#BasicProducer_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1.833 11.14c0 .173.036.339.09.494H.354a.494.494 0 0 1-.493-.495V9.168h1.973zm5.204-9.32a.5.5 0 0 1 .442 0l2.959 1.48a.5.5 0 0 1 .238.258l.986 2.466.035.183v4.932a.494.494 0 0 1-.493.493h-1.48a.493.493 0 0 1-.493-.493V8.673a.494.494 0 0 0-.493-.493h-2.96a.494.494 0 0 0-.493.493v2.466c0 .272-.22.493-.493.493h-1.48a.493.493 0 0 1-.493-.493V6.206l.035-.182.987-2.466a.5.5 0 0 1 .237-.258zM1.903 5.746l-.063.33-.007.13v1.975H-.14V5.22h2.254zm5.19-1.498c-.485.078-.821.534-.822 1.025v.688c0 .136.111.246.248.246h1.479a.246.246 0 0 0 .241-.196l.006-.05v-.74a.988.988 0 0 0-1.152-.973M2.568-.192c1.113.106 1.967.986 2.174 2.058l-1.104.552a1.48 1.48 0 0 0-.713.775l-.417 1.041H-.14V2.262A2.467 2.467 0 0 1 2.568-.192"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "BasicProducer_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
})))));
export { SvgBasicProducer as ReactComponent };
export default __webpack_public_path__ + "static/media/BasicProducer.22ce8ce7.svg";